module.exports = __webpack_public_path__ + "media/draw.699b9344.webm";